import { render, staticRenderFns } from "./SupplierCommunicate.vue?vue&type=template&id=0b6b6fd2&scoped=true"
import script from "./SupplierCommunicate.vue?vue&type=script&lang=ts"
export * from "./SupplierCommunicate.vue?vue&type=script&lang=ts"
import style0 from "./SupplierCommunicate.vue?vue&type=style&index=0&id=0b6b6fd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6b6fd2",
  null
  
)

export default component.exports